export const LocalStorage = {
	get: (key) => localStorage.getItem('etebarBourse-admin-' + key),
	set: (key, value) => localStorage.setItem('etebarBourse-admin-' + key, value),
	remove: (key) => localStorage.removeItem('etebarBourse-admin-' + key),
	clear: () => localStorage.clear()
}